import "../sass/main.scss";

//Service Workerのエラー解決用
self.addEventListener("fetch", (e) => {
  e.respondWith(
    (() => {
      return e.preloadResponse.then((res) => {
        console.info("preload res", res);
        if (res) return res;
        return fetch(e.request);
      });
    })()
  );
});

const topSwiper = () => {
  new Swiper(".top-fv__swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 1000,
    centeredSlides: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 3000,
    },
    // ページネーションが必要なら追加
    pagination: {
      el: ".top-fv__swiper .swiper-pagination",
      clickable: true,
      type: "bullets",
    },
    // ナビボタンが必要なら追加
    navigation: {
      nextEl: ".top-fv__swiper .swiper-button-next",
    },
  });
};

const breakPoint = 767;
let mySwiper;
let mySwiperBool;

const initSwiper = () => {
  mySwiper = new Swiper(".voice__swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    speed: 1000,
    centeredSlides: true,
    autoplay: {
      delay: 3000,
    },
    // ナビボタンが必要なら追加
    navigation: {
      nextEl: ".voice .swiper-button-next",
      prevEl: ".voice .swiper-button-prev",
    },
  });
};

window.addEventListener(
  "load",
  () => {
    topSwiper();
    if (breakPoint < window.innerWidth) {
      mySwiperBool = false;
    } else {
      initSwiper();
      mySwiperBool = true;
    }
  },
  false
);

window.addEventListener(
  "resize",
  () => {
    topSwiper();
    if (breakPoint < window.innerWidth && mySwiperBool) {
      mySwiper.destroy(false, true);
      mySwiperBool = false;
    } else if (breakPoint >= window.innerWidth && !mySwiperBool) {
      initSwiper();
      mySwiperBool = true;
    }
    //PCサイズ時ドロワーメニューを非表示
    if (window.innerWidth >= 768 && document.querySelector(".header__drawer.is-active")) {
      backfaceFixed(false);
      open = true;
      menuBtn.classList.remove("is-active");
      overlay.classList.remove("is-active");
      drawerMenu.classList.remove("is-active");
      pickupYoutube.classList.remove("is-active");
    }
  },
  false
);

window.addEventListener("load", function () {
  // slideUp
  function slideUp(el, duration = 500) {
    el.style.height = el.offsetHeight + "px";
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    setTimeout(() => {
      el.style.display = "none";
      el.style.removeProperty("height");
      el.style.removeProperty("padding-top");
      el.style.removeProperty("padding-bottom");
      el.style.removeProperty("margin-top");
      el.style.removeProperty("margin-bottom");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition-duration");
      el.style.removeProperty("transition-property");
      el.style.removeProperty("transition-timing-function");
    }, duration);
  }
  // slideDown
  function slideDown(el, duration = 500) {
    el.style.removeProperty("display");
    let display = window.getComputedStyle(el).display;
    if (display === "none") {
      display = "block";
    }
    el.style.display = display;
    let height = el.offsetHeight;
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.height = height + "px";
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    setTimeout(() => {
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition-duration");
      el.style.removeProperty("transition-property");
      el.style.removeProperty("transition-timing-function");
    }, duration);
  }
  // slideToggle
  function slideToggle(el, duration = 500) {
    if (window.getComputedStyle(el).display === "none") {
      return slideDown(el, duration);
    } else {
      return slideUp(el, duration);
    }
  }

  // 同じ階層の要素全て取得
  function getSiblings(e) {
    // for collecting siblings
    let siblings = [];
    // if no parent, return no sibling
    if (!e.parentNode) {
      return siblings;
    }
    // first child of the parent node
    let sibling = e.parentNode.firstChild;

    // collecting siblings
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== e) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }
    return siblings;
  }
  // 親要素の同じ階層の要素全て取得(element以外)
  function getParents(element) {
    var parent = element.parentNode;
    return getSiblings(parent);
  }

  var accordionTitles = document.querySelectorAll(".faq__item-header");
  accordionTitles.forEach((accordionTitle) => {
    accordionTitle.addEventListener("click", function () {
      accordionTitle.classList.toggle("is-active");
      slideToggle(accordionTitle.nextElementSibling);
    });
  });

  // variable
  var anchorTrigger = document.querySelectorAll('a[href^="#"]');
  if (document.querySelector(".header")) {
    var headerHeight = document.querySelector(".header").clientHeight; //ヘッダーの高さ取得
  }
  var scrollable = true; //閉じるボタンの個数だけスクロール位置を戻さないようにするフラグ
  /* smooth scroll */
  // do
  anchorTrigger.forEach((el) => {
    el.addEventListener("click", function (e) {
      e.preventDefault(); //必ず必要！デフォルトの動作キャンセル

      if (document.querySelector(".is-active")) {
        backfaceFixed(false);
        open = true;
        menuBtn.classList.remove("is-active");
        overlay.classList.remove("is-active");
        drawerMenu.classList.remove("is-active");
        pickupYoutube.classList.remove("is-active");
      }

      var href = el.getAttribute("href"); //クリックした要素のhref属性の値を読み取る
      var target = document.getElementById(href.replace("#", "")); //"#"を取り除き 要素取得
      var rect = target.getBoundingClientRect().top; //targetの画面上端からの距離
      var offset = window.scrollY; //現在のスクロール位置を取得
      var locate = rect + offset - headerHeight; //画面上端から移動先までの距離
      window.scrollTo({
        top: locate,
        behavior: "smooth",
      });
    });
  });

  // return top
  var returnTop = document.querySelectorAll(".return-top");
  returnTop.forEach((el) => {
    el.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  });

  MicroModal.init({
    disableScroll: true,
  });
});

//フォーム
// const form = document.getElementById("contact-form");
// if (form) {
//   form.addEventListener("submit", (event) => {
//     const nameInput = document.querySelector('input[name="name"]');
//     const kanaInput = document.querySelector('input[name="kana"]');
//     const zipInput = document.querySelector('input[name="zip"]');
//     const addressInput = document.querySelector('textarea[name="address"]');
//     const telInput = document.querySelector('input[name="tel"]');
//     const emailInput = document.querySelector('input[name="email"]');
//     const confirmInput = document.querySelector('input[name="confirm"]');
//     const agreeInput = document.querySelector('input[name="agree"]');
//     event.preventDefault();
//     window.location.href = "thanks";
//   });
// }

//スクロールバーの差分計算
function backfaceFixed(fixed) {
  /**
   * 表示されているスクロールバーとの差分を計測し、背面固定時はその差分body要素に余白を生成する
   */
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.body.style.paddingRight = fixed ? `${scrollbarWidth}px` : "";

  /**
   * スクロール位置を取得する要素を出力する(`html`or`body`)
   */
  const scrollingElement = () => {
    const browser = window.navigator.userAgent.toLowerCase();
    if ("scrollingElement" in document) return document.scrollingElement;
    if (browser.indexOf("webkit") > 0) return document.body;
    return document.documentElement;
  };

  /**
   * 変数にスクロール量を格納
   */
  const scrollY = fixed ? scrollingElement().scrollTop : parseInt(document.body.style.top || "0");

  /**
   * CSSで背面を固定
   */
  const styles = {
    height: "100vh",
    left: "0",
    overflow: "hidden",
    // position: "fixed",
    top: `${scrollY * -1}px`,
    width: "100vw",
  };

  Object.keys(styles).forEach((key) => {
    document.body.style[key] = fixed ? styles[key] : "";
  });

  /**
   * 背面固定解除時に元の位置にスクロールする
   */
  if (!fixed) window.scrollTo(0, scrollY * -1);
}

//ハンバーガーメニュー
const menuBtn = document.querySelector(".header__drawer");
const overlay = document.querySelector(".header__overlay");
const drawerMenu = document.querySelector(".drawer__menu");
const pickupYoutube = document.querySelector(".pickup__youtube"); //ドロワーメニュー開いてる時に勝手にクリック防止
let open = true;
if (menuBtn) {
  menuBtn.addEventListener("click", () => {
    backfaceFixed(open);
    open = !open;
    menuBtn.classList.toggle("is-active");
    overlay.classList.toggle("is-active");
    drawerMenu.classList.toggle("is-active");
    pickupYoutube.classList.toggle("is-active");
  });
}
